import { Component, OnInit,Input, SimpleChanges } from '@angular/core';
interface BalanceSheetData {
   label: string;
   data: Record<number, number>;
   children?: BalanceSheetData[];
 }

 interface QuarterlyBalanceSheetData {
   label: string;
   data: Record<string, number>;
   children?: QuarterlyBalanceSheetData[];
   isExpanded?: boolean;
 }

@Component({
    selector: 'app-balancesheet-table',
    templateUrl: './balancesheet-table.component.html',
    styleUrls: ['./balancesheet-table.component.scss'],
    standalone: false
})
export class BalancesheetTableComponent implements OnInit {

  @Input() _isAnnual:boolean=true;
     @Input() grossMarginAnnualArray: any[] = [];


     @Input() grossMarginQuarterlyArray: any[] = [];
     @Input() data: any[] = [];
     @Input() quarterlydata: any[] = [];

     filteredAnnualData: any[] = [];
    filteredQuarterlyData: any[] = [];

    noDataAnnual:boolean=false
  noDataQuarterly:boolean=false


     years: number[] = [];
     quarters: string[] = [];
     quarters2: string[] = [];




     expandedRows: Record<string, boolean> = {};
     expandedRows2: Record<string, boolean> = {};
     processedData: any[] = [];
   processedQuarterlyData: any[] = [];
     expandedItems: Set<string> = new Set();





  ;
    constructor() { }





       ngOnInit(): void {
        this.processAndSetData();
       }

       ngOnChanges(changes: SimpleChanges): void {
        if (changes['quarterlydata'] && changes['quarterlydata'].currentValue) {
         //   console.log('Quarterly data changed:', changes['quarterlydata'].currentValue);
           this.processAndSetData();
        }
     }

     private processAndSetData() {
      this.processedData = this.processDataWithHierarchy(this.data);
      this.processedQuarterlyData = this.processDataWithHierarchy(this.quarterlydata);
      // console.log('Processed Quarterly Data:', this.processedQuarterlyData);

      // Extract latest years from annual data
      this.years = this.extractLatestYears(this.data);

      // Extract latest 4 quarters from quarterly data
      this.quarters = this.extractLatestQuarters(this.quarterlydata);
      this.quarters2 = this.extractLatestQuarters(this.quarterlydata);

      this.noDataAnnual = !this.hasAnnualData(this.data);
      this.noDataQuarterly = !this.hasQuarterlyData(this.quarterlydata);
    }


    private initializeExpansionState(items: QuarterlyBalanceSheetData[]) {
      if (!items?.length) return;

      items.forEach(item => {
        if (item?.children?.length) {
          item.isExpanded = false;
          this.initializeExpansionState(item.children);
        }
      });
    }

    getFormattedValue = (data: { [key: string]: string } | undefined, quarter: string): string => {
      if (!data || !data[quarter]) return '-'; // Return dash if no data or missing quarter

      let value = parseFloat(data[quarter]); // Convert string to number

      if (isNaN(value)) return '-'; // Return dash if value is not a valid number

      // Multiply the number by 10,00,000
      value *= 1_000_000;

      const absValue = Math.abs(value); // Get absolute value
      const formattedValue = (val: number) => val.toFixed(2).replace(/\.?0+$/, ''); // Ensure up to 2 decimal places

      let result: string;

      // Handle billions
      if (absValue >= 1_000_000_000) {
         result = formattedValue(absValue / 1_000_000_000) + ' B';
      }
      // Handle millions
      else if (absValue >= 1_000_000) {
         result = formattedValue(absValue / 1_000_000) + ' M';
      }
      // Handle smaller values
      else {
         result = formattedValue(absValue); // Use absValue instead of value
      }

      // Show negative values in parentheses (without minus sign)
      return value < 0 ? `(${result})` : result;
   };




    formatNumber(value: string): string {
      if (!value) return '-';
      try {
        const number = parseFloat(value);
        return new Intl.NumberFormat('en-US', {
          style: 'decimal',
          maximumFractionDigits: 0
        }).format(number);
      } catch {
        return '-';
      }
    }




   //  formatNumber(value: string | number | undefined): string {
   //    if (!value) return 'N/A';
   //    const num = typeof value === 'string' ? parseFloat(value) : value;
   //    return num.toLocaleString('en-US', {
   //      minimumFractionDigits: 2,
   //      maximumFractionDigits: 2
   //    });
   //  }


   processDataWithHierarchy(data: BalanceSheetData[]): BalanceSheetData[] {
      const hierarchicalData: BalanceSheetData[] = [];
      const includedLabels = new Set<string>();

      // Helper function to find item by label
      const findItem = (label: string): BalanceSheetData | undefined => {
          const item = data.find(item => item.label === label);
          if (item) includedLabels.add(label);
          return item;
      };

      // Helper function to create children array with type safety
      const createChildren = (items: (BalanceSheetData | undefined)[]): BalanceSheetData[] =>
          items.filter((item): item is BalanceSheetData => item !== undefined);

      // Process Net Income section
      const totalAssets = findItem('totalAssets');
      if (totalAssets) {
          const currentAssets = findItem('currentAssets');
          const propertyPlantEquipment = findItem('propertyPlantEquipment');
          const accumulatedDepreciation = findItem('accumulatedDepreciation');
          const longTermInvestments = findItem('longTermInvestments');
          const noteReceivableLongTerm = findItem('noteReceivableLongTerm');
          const otherLongTermAssets = findItem('otherLongTermAssets');
          const goodwill = findItem('goodwill');
          const intangiblesAssets = findItem('intangiblesAssets');
          const cashShortTermInvestments = findItem('cashShortTermInvestments');

          // If currentAssets exists, add its children
          if (currentAssets) {
              currentAssets.children = createChildren([
                  cashShortTermInvestments,
                  findItem('accountsReceivables'),
                  findItem('inventory'),
                  findItem('otherCurrentAssets'),
                  // You can add more items if needed
              ]);
          }

          // If you want to add children to cashShortTermInvestments itself:
          if (cashShortTermInvestments) {
              cashShortTermInvestments.children = createChildren([
                  // List any child nodes for cashShortTermInvestments
                  findItem('cash'),
                  findItem('cashEquivalents'),
                  findItem('shortTermInvestments')
                  // ... add as many as needed
              ]);
          }

          totalAssets.children = createChildren([
              currentAssets,
              propertyPlantEquipment,
              accumulatedDepreciation,
              longTermInvestments,
              noteReceivableLongTerm,
              otherLongTermAssets,
              goodwill,
              intangiblesAssets
          ]);
          hierarchicalData.push(totalAssets);
      }


   // Process Total Liabilities section
   const totalLiabilities = findItem('totalLiabilities');
   if (totalLiabilities) {
       const currentLiabilities = findItem('currentLiabilities');
       const longTermDebt = findItem('longTermDebt');
       const netDebt = findItem('netDebt');
       const otherLiabilities = findItem('otherLiabilities');
       const totalDebt = findItem('totalDebt');

       if (currentLiabilities) {
           currentLiabilities.children = createChildren([
               findItem('accountsPayable'),
               findItem('accruedLiability'),
               findItem('shortTermDebt'),
               findItem('currentPortionLongTermDebt'),
               findItem('otherCurrentliabilities'),
           ]);
       }

      //  if (nonCurrentLiabilities) {
      //      nonCurrentLiabilities.children = createChildren([
      //          findItem('Other non-current liabilities'),
      //          findItem('Term debt'),
      //      ]);
      //  }

       totalLiabilities.children = createChildren([currentLiabilities,longTermDebt,netDebt,otherLiabilities,totalDebt ]);
       hierarchicalData.push(totalLiabilities);
   }

   // Process Total Liabilities and Shareholders' Equity section
   const totalLiabilitiesAndEquity = findItem("Total liabilities and shareholders’ equity");
   if (totalLiabilitiesAndEquity) {
       const shareholdersEquity = findItem("Total shareholders’ equity");

       if (shareholdersEquity) {
           shareholdersEquity.children = createChildren([
               findItem("Common stock and additional paid-in capital, $0.00001 par value: 50,400,000 shares authorized; 16,976,763 and 17,772,945 shares issued and outstanding, respectively"),
               findItem("Accumulated deficit"),
               findItem("Accumulated other comprehensive income/(loss)"),
           ]);
       }

       totalLiabilitiesAndEquity.children = createChildren([shareholdersEquity]);
       hierarchicalData.push(totalLiabilitiesAndEquity);
   }

      // Find remaining items that were not included
      const remainingItems = data.filter(item => !includedLabels.has(item.label));

      // Append remaining items at the bottom
      hierarchicalData.push(...remainingItems);

      return hierarchicalData;
  }


  processDataWithHierarchy2(data: QuarterlyBalanceSheetData[]): QuarterlyBalanceSheetData[] {
   const hierarchicalData: QuarterlyBalanceSheetData[] = [];
   const includedLabels = new Set<string>();

   // Helper function to find item by label
   const findItem = (label: string): QuarterlyBalanceSheetData | undefined => {
       const item = data.find(item => item.label === label);
       if (item) includedLabels.add(label);
       return item;
   };

   // Helper function to create children array with type safety
   const createChildren = (items: (QuarterlyBalanceSheetData | undefined)[]): QuarterlyBalanceSheetData[] =>
       items.filter((item): item is QuarterlyBalanceSheetData => item !== undefined);

   // Process Total Assets section
   const totalAssets = findItem('Total assets');
   if (totalAssets) {
       const currentAssets = findItem('Total current assets');
       const nonCurrentAssets = findItem('Total non-current assets');

       if (currentAssets) {
           currentAssets.children = createChildren([
               findItem('Cash and cash equivalents'),
               findItem('Marketable securities'),
               findItem('Accounts receivable, net'),
               findItem('Vendor non-trade receivables'),
               findItem('Inventories'),
               findItem('Other current assets'),
           ]);
       }

       if (nonCurrentAssets) {
           nonCurrentAssets.children = createChildren([
               findItem('Marketable securities'),
               findItem('Property, plant and equipment, net'),
               findItem('Other non-current assets'),
           ]);
       }

       totalAssets.children = createChildren([currentAssets, nonCurrentAssets]);
       hierarchicalData.push(totalAssets);
   }

   // Process Total Liabilities section
   const totalLiabilities = findItem('Total liabilities');
   if (totalLiabilities) {
       const currentLiabilities = findItem('Total current liabilities');
       const nonCurrentLiabilities = findItem('Total non-current liabilities');

       if (currentLiabilities) {
           currentLiabilities.children = createChildren([
               findItem('Accounts payable'),
               findItem('Other current liabilities'),
               findItem('Deferred revenue'),
               findItem('Commercial paper'),
               findItem('Term debt'),
           ]);
       }

       if (nonCurrentLiabilities) {
           nonCurrentLiabilities.children = createChildren([
               findItem('Other non-current liabilities'),
           ]);
       }

       totalLiabilities.children = createChildren([currentLiabilities, nonCurrentLiabilities]);
       hierarchicalData.push(totalLiabilities);
   }

   // Process Total Liabilities and Shareholders' Equity section
   const totalLiabilitiesAndEquity = findItem("Total liabilities and shareholders’ equity");
   if (totalLiabilitiesAndEquity) {
       const shareholdersEquity = findItem("Total shareholders’ equity");

       if (shareholdersEquity) {
           shareholdersEquity.children = createChildren([
               findItem("Common stock and additional paid-in capital, $0.00001 par value: 50,400,000 shares authorized; 16,976,763 and 17,772,945 shares issued and outstanding, respectively"),
               findItem("Accumulated deficit"),
               findItem("Accumulated other comprehensive income/(loss)"),
           ]);
       }

       totalLiabilitiesAndEquity.children = createChildren([shareholdersEquity]);
       hierarchicalData.push(totalLiabilitiesAndEquity);
   }

   // Find remaining items that were not included
   const remainingItems = data.filter(item => !includedLabels.has(item.label));

   // Append remaining items at the bottom
   hierarchicalData.push(...remainingItems);

   return hierarchicalData;
}





    toggleRow(item: BalanceSheetData) {
      this.expandedRows[item.label] = !this.expandedRows[item.label];
    }
    toggleRow2(item: QuarterlyBalanceSheetData) {
      this.expandedRows2[item.label] = !this.expandedRows2[item.label];
    }

    private openRows: Set<string> = new Set();

    getYears(data: Record<number, number>): number[] {
      return Object.keys(data).map(year => parseInt(year)); // Get years from the data object keys
    }

    private extractLatestYears(annualData: any[]): number[] {
      if (!annualData || annualData.length === 0) {
         return [];
      }

      // Collect all unique years from all data items
      const allYears = new Set<number>();
      annualData.forEach(item => {
         if (item.data) {
            Object.keys(item.data).forEach(year => {
               const yearNum = parseInt(year);
               if (!isNaN(yearNum)) {
                  allYears.add(yearNum);
               }
            });
         }
      });

      // Convert to array and sort years chronologically
      const sortedYears = Array.from(allYears).sort((a, b) => a - b);

      // Return the latest 5 years (last 5 from the sorted array)
      return sortedYears.slice(-5);
    }

    private extractLatestQuarters(quarterlyData: any[]): string[] {
      if (!quarterlyData || quarterlyData.length === 0) {
         return [];
      }

      // Collect all unique quarters from all data items
      const allQuarters = new Set<string>();
      quarterlyData.forEach(item => {
         if (item.data) {
            Object.keys(item.data).forEach(quarter => {
               allQuarters.add(quarter);
            });
         }
      });

      // Convert to array and sort quarters chronologically
      const sortedQuarters = Array.from(allQuarters).sort((a, b) => {
         // Parse quarter format like "Q1'25" to sort chronologically
         const parseQuarter = (q: string) => {
            const [quarter, year] = q.split("'");
            const quarterNum = parseInt(quarter.substring(1));
            const fullYear = parseInt(year) + 2000; // Convert '25 to 2025
            return fullYear * 4 + quarterNum; // Create sortable number
         };

         return parseQuarter(a) - parseQuarter(b); // Sort ascending (oldest first)
      });

      // Return the latest 4 quarters (last 4 from the sorted array)
      return sortedQuarters.slice(-4);
    }


    toggleAccordion(row: string): void {
      if (this.openRows.has(row)) {
        this.openRows.delete(row); // Close the accordion
      } else {
        this.openRows.add(row); // Open the accordion
      }
    }

    isAccordionOpen(row: string): boolean {
      return this.openRows.has(row); // Check if the accordion is open
    }
    hasData(data: any): boolean {
      return this.quarters.some(q => data[q] !== undefined && data[q] !== null);
    }

    hasAnnualData(data: { label: string; data: Record<string, number> }[]): boolean {
      return data.some(item =>
        Object.keys(item.data).some(year => this.years.includes(Number(year)))
      );
    }

    hasQuarterlyData(quarterlyData: { label: string; data: Record<string, number> }[]): boolean {
      return quarterlyData.some(item =>
        Object.keys(item.data).some(quarter => this.quarters.includes(quarter))
      );
    }


    formatValue = (value: number | string | undefined): string => {
      if (value === undefined || value === null || value === '') {
         return '-';
      }

      // Convert string values to numbers
      let numericValue = typeof value === 'string' ? parseFloat(value) : value;

      // Handle NaN cases (e.g., invalid strings)
      if (isNaN(numericValue)) {
         return '-';
      }

      // Multiply by 10,00,000
      numericValue *= 1_000_000;

      const absValue = Math.abs(numericValue);
      const formattedValue = (val: number) =>
         val.toFixed(2).replace(/\.?0+$/, '');

      let result: string;

      // Handle billions
      if (absValue >= 1_000_000_000) {
         result = formattedValue(absValue / 1_000_000_000) + ' B';
      }
      // Handle millions
      else if (absValue >= 1_000_000) {
         result = formattedValue(absValue / 1_000_000) + ' M';
      }
      // Handle decimal numbers
      else {
         result = formattedValue(absValue);
      }

      // Show negative values in parentheses without a negative sign
      return numericValue < 0 ? `(${result})` : result;
   };


   // toggleChildren(item: any) {
   //    item.expanded = !item.expanded;
   //    console.log("Toggled item:", item); // Debugging statement
   //  }

    hasData2(data: any): boolean {
      return data && Object.keys(data).length > 0;
    }

    trackByFn(index: number, item: any): any {
      return item.id; // Use a unique identifier for each item
    }
    toggleItem(label: string): void {
      if (this.expandedItems.has(label)) {
        this.expandedItems.delete(label);
      } else {
        this.expandedItems.add(label);
      }
    }

    isItemExpanded(label: string): boolean {
      return this.expandedItems.has(label);
    }
    expanded: boolean = false;
    toggleExpand() {
      this.expanded = !this.expanded;
    }




}
